import { render } from "./SandboxCredentials.vue?vue&type=template&id=1c75e5ee"
import script from "./SandboxCredentials.vue?vue&type=script&lang=js"
export * from "./SandboxCredentials.vue?vue&type=script&lang=js"

import "./SandboxCredentials.vue?vue&type=style&index=0&id=1c75e5ee&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__